import * as React from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

interface Message {
    key?: string;
    text: string;
    className: 'info' | 'warning' | 'error' | 'debug';
    timeout?: number;
}

class State {
    messages: Message[];
}

class Props {
    defaultTimeout?: number;
}

let sharedToaster: Toaster;

export class Toaster extends React.Component<Props, State> {

    private static makeKey() {
        // make a key of random letters and numbers (including lower and upper case)
        let key = '';
        for (let i = 0; i < 5; i++) {
            const x = Math.random() * 62;
            if (x < 26)
                key += String.fromCharCode(65 + x);
            else if (x < 52)
                key += String.fromCharCode(97 + (x - 26));
            else
                key += String.fromCharCode(48 + (x - 52));
        }
        return key;
    }

    componentWillMount(): void {
        // not liking a single static Toaster, but how else will we be able to access and add popups
        // without a static object.
        if (!sharedToaster)
            sharedToaster = this;
        this.setState({ messages: [] });
    }

    popup(m: Message): void {
        if (! m.key)
            m.key = Toaster.makeKey();
        if (! m.timeout)
            m.timeout = this.props.defaultTimeout;
        // do the set state after a delay so we dont setState from within a render()
        this.setState( (prevState) => ({ messages: [...prevState.messages, m ]}) );
        setTimeout( () => this.remove(m), m.timeout );

    }

    render() {
        if (this !== sharedToaster)
            return null;    // dont render unless you are the one and only toaster
        const { messages } = this.state;

        return (
            <div className="toaster">
                <TransitionGroup component={null}>
                { messages.map((m, idx) => (
                    <CSSTransition key={m.key} timeout={500} classNames="toast-fader">
                        <div key={m.key} className={`toast toast-${m.className}`}>{m.text}</div>
                    </CSSTransition>
                ))}
                </TransitionGroup>
            </div>
        );
    }

    private remove(m: Message) {
        this.setState( prevState => ({
            // include all messages except the one we want to remove
            messages: prevState.messages.filter( (_m) => _m.key !== m.key )
        }));
    }
}

/* Our public interface to creating toast messages
 */
const Toast = {
    info(text: string, timeout?: number) {
        sharedToaster.popup({ text, timeout: timeout, className: 'info' });
    },

    warning(text: string, timeout?: number) {
        sharedToaster.popup({ text, timeout: timeout || 3500, className: 'warning' });
    },

    error(text: string, timeout?: number) {
        sharedToaster.popup({ text, timeout: timeout || 4000, className: 'error' });
    },

    debug(text: string, timeout?: number) {
        sharedToaster.popup({ text, timeout: timeout || 8000, className: 'debug' });
    }
};

export default Toast;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/sys/toast.tsx